module.exports = __webpack_public_path__ + "static/media/4-6.685d23a2.png";